import $ from 'jquery'
import { Core } from './core'

export class Sticky {

  constructor () {
    this.$body = $('body')
    this.$header = $('header')

    this.stickyClasses = {
      top: 'js-sticky-top',
      middle: 'js-sticky-middle',
      bottom: 'js-sticky-bottom'
    }

    this.stickyDatas = {
      bp: 'js-sticky-bp',
      mobile: 'js-sticky-mobile',
      desktop: 'js-sticky-desktop',
      parentTop: 'js-sticky-parent-top',
      parentBottom: 'js-sticky-parent-bottom'
    }

    this.submenuNavigationClass = 'submenu-navigation-content'
    this.$submenuNavigation = $(`.${this.submenuNavigationClass}`)

    this.handleStickyNav()
    $(window).on('resize scroll', this.handleStickyNav.bind(this))
  }

  handleStickyNav () {
    $(`[data-${this.stickyDatas.mobile}], [data-${this.stickyDatas.desktop}]`).each(this.stickyNav.bind(this))
  }

  stickyNav (index, element) {
    let $element = $(element)
    let scrollTop = $(window).scrollTop()
    let windowHeaderTop = this.$header.offset().top - scrollTop + this.$header.outerHeight()

    if (! $element.hasClass(this.submenuNavigationClass) && this.$submenuNavigation.length > 0) {
      windowHeaderTop = this.$submenuNavigation.offset().top - scrollTop + this.$submenuNavigation.outerHeight(true)
    }

    const $bannerTop = this.$body.find('.banner-top');
    if ( $bannerTop.length ) {
      windowHeaderTop += $bannerTop.outerHeight();
    }

    // For "popular" badge overlapping on top
    windowHeaderTop += 16;

    let scrollTopHeader = scrollTop + windowHeaderTop
    let stickyBp = $element.data(this.stickyDatas.bp)

    if (Core.isBpGreaterThan(stickyBp)) {
      if ($element.data(this.stickyDatas.desktop) === undefined) {
        this.resetClasses($element)
        return
      }
    } else {
      if ($element.data(this.stickyDatas.mobile) === undefined) {
        this.resetClasses($element)
        return
      }
    }

    let $stickyParentTop = $element.parent()
    let $stickyParentBottom = $element.parent()

    if ($element.data(this.stickyDatas.parentTop) !== undefined) {
      $stickyParentTop = $($element.data(this.stickyDatas.parentTop))
    }
    if ($element.data(this.stickyDatas.parentBottom) !== undefined) {
      $stickyParentBottom = $($element.data(this.stickyDatas.parentBottom))
    }

    let stickyTop = $stickyParentTop.offset().top
    let stickyBottom = $stickyParentBottom.offset().top + $stickyParentBottom.outerHeight(true) - $element.outerHeight(true)

    $element.removeClass(this.stickyClasses.top)
    $element.removeClass(this.stickyClasses.middle)
    $element.removeClass(this.stickyClasses.bottom)

    $element.removeAttr('style')

    if (scrollTopHeader < stickyTop) {
      $element.addClass(this.stickyClasses.top).trigger('sticky:top')
    } else if (scrollTopHeader > stickyBottom) {
      $element.addClass(this.stickyClasses.bottom).trigger('sticky:bottom')
    } else {
      $element.css('top', windowHeaderTop)
      $element.css('left', $element.offset().left)
      $element.css('width', $element.outerWidth())
      $element.addClass(this.stickyClasses.middle).trigger('sticky:middle')
    }
  }

  resetClasses ($element) {
    $element.removeClass(`${this.stickyClasses.top} ${this.stickyClasses.middle} ${this.stickyClasses.bottom}`)
    $element.removeAttr('style')
  }
}
